/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function FloppyDiskBack(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M208,31.99963H168V80.0094a8.00039,8.00039,0,0,1-8,8H96a8,8,0,0,1,0-16h56V31.99963H91.31348A15.89171,15.89171,0,0,0,80,36.68616L36.68555,79.99963A15.898,15.898,0,0,0,32,91.31409V207.99963a16.01833,16.01833,0,0,0,16,16H208a16.01833,16.01833,0,0,0,16-16v-160A16.01833,16.01833,0,0,0,208,31.99963ZM128,176a28,28,0,1,1,28-28A28.0316,28.0316,0,0,1,128,176Z" />
    </Svg>
  );
}

export default FloppyDiskBack;
